/**
 * @generated SignedSource<<2f32a74b535fb2ebded65f3f1e726301>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type App = "Doxie" | "Mays" | "Music" | "RendAHand" | "%future added value";
export type SocialLoginService = "APPLE" | "FACEBOOK" | "GOOGLE" | "%future added value";
export type SocialLoginInput = {
  app: App;
  service: SocialLoginService;
  token: string;
};
export type SocialLoginMutation$variables = {
  input: SocialLoginInput;
};
export type SocialLoginMutation$data = {
  readonly social_login: {
    readonly access_token: string;
  };
};
export type SocialLoginMutation = {
  variables: SocialLoginMutation$variables;
  response: SocialLoginMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AuthenticationOutput",
    "kind": "LinkedField",
    "name": "social_login",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "access_token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SocialLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SocialLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed842abc00904753548b206e9b9a1c8f",
    "id": null,
    "metadata": {},
    "name": "SocialLoginMutation",
    "operationKind": "mutation",
    "text": "mutation SocialLoginMutation(\n  $input: SocialLoginInput!\n) {\n  social_login(input: $input) {\n    access_token\n  }\n}\n"
  }
};
})();

(node as any).hash = "a44c7523961621be23545948f1f640bf";

export default node;
